import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by `Application/SubjectTypeDefinitions/**`.
 * A failure shows the server message; the static one is only the fallback. A fetch failure is not
 * covered: the screens surface it inline, with a retry.
 */
const SubjectTypesNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="SUBJECT_TYPE_DEFINITION_SAVED"
				title="Type enregistré"
				message="Type enregistré."
			/>
			<SuccessNotification
				eventName="SUBJECT_TYPE_ARCHIVED"
				title="Type archivé"
				message="Type archivé."
			/>
			<SuccessNotification
				eventName="SUBJECT_TYPE_RESTORED"
				title="Type restauré"
				message="Type restauré."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_TYPE_GRANTS_SAVED"
				title="Accès enregistré"
				message="Accès enregistré."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_TYPE_GRANTS_SAVE_FAILED"
				title="Enregistrement refusé"
				message="L'accès n'a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="SUBJECT_TYPE_DEFINITION_SAVE_FAILED"
				title="Enregistrement refusé"
				message="Le type de dossier n’a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="SUBJECT_TYPE_ARCHIVE_FAILED"
				title="Erreur"
				message="Le type de dossier n’a pas pu être archivé."
			/>
			<ErrorNotification
				eventName="SUBJECT_TYPE_RESTORE_FAILED"
				title="Erreur"
				message="Le type de dossier n’a pas pu être restauré."
			/>
		</React.Fragment>
	);
};

export default SubjectTypesNotifications;
